/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Day_VisitsInputs */

const en_platform_day_visits = /** @type {(inputs: Platform_Day_VisitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`visits today, all booked by clients`)
};

const pl_platform_day_visits = /** @type {(inputs: Platform_Day_VisitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wizyt dziś, wszystkie zarezerwowane przez podopiecznych`)
};

/**
* | output |
* | --- |
* | "visits today, all booked by clients" |
*
* @param {Platform_Day_VisitsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_day_visits = /** @type {((inputs?: Platform_Day_VisitsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Day_VisitsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_day_visits(inputs)
	return en_platform_day_visits(inputs)
});